export default "__VITE_ASSET__C$Uu2_fk__"